import { api } from "./api";
const apiUrl = "https://admin.bcuni.eu/api";
const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addLessonDocument: builder.mutation({
      query: (data) => ({
        url: `${apiUrl}/lesson-document/add`,
        method: "POST",
        body: { data },
        credentials: "include",
      }),
    }),
    getLessonDocuments: builder.query({
      query: (data) => ({
        url: `${apiUrl}/lesson-document/list`,
        method: "POST",
        body: { data },
        credentials: "include",
      }),
    }),
    getStudentLessonDocuments: builder.query({
      query: (data) => ({
        url: `${apiUrl}/lesson-document/student/list`,
        method: "POST",
        body: { data },
        credentials: "include",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddLessonDocumentMutation,
  useGetLessonDocumentsQuery,
  useGetStudentLessonDocumentsQuery,
} = extendedApi;
